import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { ScrollableContent } from '@/components/scroll/scrollableContent';
import { ScrollableWrapper } from '@/components/scroll/scrollableContext';
import { ScrollableHeader } from '@/components/scroll/scrollableHeader';
import { useScrollable } from '@/components/scroll/useScrollable';
import { pluralize } from '@/utils/string';
import { SelectedItemsBody } from './selectedItemsBody';
import { SelectedItemsHeader } from './selectedItemsHeader';
interface SelectedItemsBoxProps<T> {
  items: T[];
  entityType: string;
  renderItem: (item: T) => React.ReactNode;
  itemKey: (item: T) => string;
  onRemove: (item: T) => void;
  clearAll: () => void;
}
export const SelectedItemsBox = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Stack className="overflow-hidden"><ScrollableWrapper><SelectedItemsBoxContent {...props} /></ScrollableWrapper></Stack>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const SelectedItemsBoxContent = t0 => {
  const $ = _c(16);
  const {
    items,
    entityType,
    renderItem,
    itemKey,
    onRemove,
    clearAll
  } = t0;
  const {
    setIsScrolledVertically
  } = useScrollable();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: "0 24px 12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== entityType || $[2] !== items.length) {
    t2 = items.length === 1 ? entityType : pluralize(entityType);
    $[1] = entityType;
    $[2] = items.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${items.length} ${t2} added`;
  let t4;
  if ($[4] !== clearAll || $[5] !== t3) {
    t4 = <ScrollableHeader hideBorderWhenOnTop={true}><Stack sx={t1}><SelectedItemsHeader title={t3} clearAll={clearAll} /></Stack></ScrollableHeader>;
    $[4] = clearAll;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== itemKey || $[8] !== items || $[9] !== onRemove || $[10] !== renderItem || $[11] !== setIsScrolledVertically) {
    t5 = <ScrollableContent><SelectedItemsBody items={items} renderItem={renderItem} itemKey={itemKey} onRemove={onRemove} onScrollVerticallyChange={setIsScrolledVertically} /></ScrollableContent>;
    $[7] = itemKey;
    $[8] = items;
    $[9] = onRemove;
    $[10] = renderItem;
    $[11] = setIsScrolledVertically;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};